import React from 'react';
import styled from 'styled-components';
import { pxToRem } from '../../lib/utils';
import { addFocusStyle } from '../../lib/mixins';

const StyledWrapper = styled.div`
  display: flex;
  min-height: 100%;
  flex-direction: column;
  background-color: ${({ hasLightBg, theme }) => (hasLightBg ? theme.colors.b : theme.colors.c)};
  justify-content: space-between;
`;

const StyledErrorBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 10rem auto 0 auto;
  width: 90%;
`;

const StyledButton = styled.button`
  padding: ${pxToRem(15)} ${pxToRem(25)};
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${pxToRem(18)};
  font-weight: 700;
  line-height: normal;
  text-align: center;
  border: 1px solid;
  border-radius: 100rem;
  transition: background-color 0.3s ease-in-out, color 0.2s ease-in-out;
  cursor: pointer;
  overflow: visible;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  &:not(:disabled):hover {
    color: ${({ theme }) => theme.colors.b};
    background-color: ${({ theme }) => theme.colors.e};
    border-color: ${({ theme }) => theme.colors.e};
  }

  &:not(:disabled):focus {
    ${addFocusStyle()}
  }
`;

const ErrorPage = () => (
  <StyledErrorBox>
    <h2>Si è verificato un errore.</h2>
    <p>Si prega di riprovare o di contattare l'assitenza clienti.</p>
    <StyledButton onClick={(e) => (document.location = '/')}>Torna alla Homepage</StyledButton>
  </StyledErrorBox>
);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <StyledWrapper hasLightBg>
          <ErrorPage />
        </StyledWrapper>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
